<template>
  <div
    v-if="isLoading"
    class="loading-global-box"
  >
    <LoadingIcon
      :isLoading="true"
      :size="size"
    />
  </div>
</template>

<script>
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    props: {
      isLoading: { type: Boolean, default: true },
      size: { type: String, default: 'lg' }
    },
    components: {
      LoadingIcon
    }
  }
</script>

<style scoped lang="scss">
  .loading-global-box {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background: rgba(#fff, .85);
    background: transparent;
    z-index: 100;
  }
</style>